import PropTypes from 'prop-types'
import styled from 'styled-components'
import React from 'react'
import { connect } from 'react-redux'
import { FormGroup as Base } from 'react-bootstrap'
import { getValueAndFieldByModel } from 'utils/form'

/**
 * Wrapper for react-bootstrap's FormGroup component to apply our own styling
 *
 * Add's error or success class based on model validity
 */
const propTypes = {
  field: PropTypes.shape({
    valid: PropTypes.bool,
    touched: PropTypes.bool,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  name: PropTypes.string,
}

const defaultProps = {
  children: undefined,
  name: '',
}

const StyledBase = styled(Base)`
  margin-top: ${({ theme }) => theme.space.s16};
`

export function FormGroup({ field, children, name }) {
  return (
    <StyledBase
      name={name}
      validationState={!field.valid && field.touched ? 'error' : null}
    >
      {children}
    </StyledBase>
  )
}

FormGroup.propTypes = propTypes
FormGroup.defaultProps = defaultProps

export default connect((state, { model }) => {
  const { field = {} } = getValueAndFieldByModel(state, model)
  return { field }
})(FormGroup)
